import { render, staticRenderFns } from "./TransactionCouponHistory.vue?vue&type=template&id=4f61ce40"
import script from "@/scripts/payment/transactionCouponHistory.js?vue&type=script&lang=js&external"
export * from "@/scripts/payment/transactionCouponHistory.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports